<h3>Answers</h3>
<pre style="height: 400px;">{{ model.answers | json }}</pre>

<button (click)="runsubmit()">Run Submit Stage</button>
